var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-pagination"},[_c('Paginator',{attrs:{"rows":_vm.step,"always-show":_vm.showPagination,"total-records":_vm.count,"first":_vm.start,"rows-per-page-options":_vm.stepsArray},on:{"page":function($event){return _vm.onPage($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }